import { Component, Input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { SwiperOptions } from 'swiper/types/swiper-options';

import { SwiperDirective } from 'src/app/shared/directives/swiper.directive';

import { TripCardComponent } from 'src/app/shared/components/trip-card/trip-card.component';

@Component({
    selector: 'app-trips-list',
    templateUrl: './trips-list.component.html',
    styleUrls: ['./trips-list.component.scss'],
    imports: [SwiperDirective, TripCardComponent, NgTemplateOutlet]
})
export class TripsListComponent {
  @Input() trips: any[];
  @Input() type: string;
  @Input() country: string;
  @Input() isFetching: boolean = false;

  fetchingTrips: number[] = new Array(10);

  swiperOptions: SwiperOptions = {
    autoplay: {
      delay: 5250,
    },
    speed: 1200,
    slidesPerView: 4.5,
    spaceBetween: 24,
    breakpoints: {
      1000: {
        slidesPerView: 3.5,
      },
      1440: {
        slidesPerView: 4.5,
      },
    },
  };
}
